export default "/_next/static/images/66cfa201ea2637534ffb13845e9c6081.png";